import React from "react";
import { IoWarning } from 'react-icons/io5';
import "./AvisoVazio.css";

const AvisoVazio = ({ 
    titulo, 
    mensagem, 
    mensagemDestaque,
    onClickDestaque
}) => {
    return (
      <div className="aviso-vazio-container">
        <div className="aviso-vazio-icone">
          <IoWarning />
        </div>
        {titulo && <h2 className="aviso-vazio-titulo">{titulo}</h2>}
        {(mensagem || mensagemDestaque) && (
          <div className="aviso-vazio-linha-mensagem">
            {mensagem && <span className="aviso-vazio-mensagem">{mensagem}&nbsp;</span>}
            {mensagemDestaque && (
              <span 
                className="aviso-vazio-destaque"
                onClick={onClickDestaque}
                style={{cursor: onClickDestaque ? 'pointer' : 'default'}}
              >
                {mensagemDestaque}
              </span>
            )}
          </div>
        )}
      </div>
    );
};

export default AvisoVazio;